import { createTheme } from '@mui/material/styles';

// Color palette from the email template
const theme = createTheme({
  palette: {
    primary: {
      main: '#322954', // Purple color from header
      contrastText: '#fff',
    },
    secondary: {
      main: '#F96302', // Orange color from footer
      contrastText: '#fff',
    },
    background: {
      default: '#f6f6f6',
      paper: '#fff',
    },
    text: {
      primary: '#333',
      secondary: '#666',
    },
  },
  typography: {
    fontFamily: 'Arial, sans-serif',
    h1: {
      fontWeight: 600,
    },
    h2: {
      fontWeight: 500,
    },
    h3: {
      fontWeight: 500,
    },
    button: {
      textTransform: 'none',
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '8px 16px',
        },
      },
    },
  },
});

export default theme;